export type Review = {
  author: string;
  avatar: string;
  source: 'Facebook' | 'Google';
  body: string;
};

export const reviews: Review[] = [
  {
    author: 'Suden Redkrik',
    avatar: '/images/reviews/sudenredkirk.webp',
    source: 'Facebook',
    body:
      'Highly recommend Bliss Building Contractors. From start to finish, the team was professional, reliable, and transparent. Communication was excellent throughout the project, timelines were met, and the quality of workmanship exceeded expectations. They paid great attention to detail and clearly take pride in their work. A stress-free experience with outstanding results. I wouldn’t hesitate to use them again or recommend them to others.',
  },
  {
    author: 'Emilian Martim',
    avatar: '/images/reviews/emilliammartim.webp',
    source: 'Facebook',
    body:
      'Bliss Building Contractors delivered an outstanding service from start to finish. Their professionalism, clear communication, and attention to detail really stood out. The team was reliable, worked to schedule, and maintained a high standard of workmanship throughout the project. Any questions or changes were handled promptly and transparently, which made the whole process stress-free. I’m extremely happy with the final result.',
  },
  {
    author: 'Tony Salper',
    avatar: '/images/reviews/tonysalper.webp',
    source: 'Facebook',
    body:
      'Highly recommend Bliss Building Contractors. From start to finish, their professionalism, workmanship, and attention to detail were outstanding. Communication was clear and consistent, timelines were respected, and the final result exceeded expectations. The team was reliable, skilled, and genuinely cared about delivering quality work. If you’re looking for a contractor you can trust, Bliss Building Contractors are an excellent choice.',
  },
];
